<template>
    <div class="placeload">
        <div class="image-placeholder loads" :style="{ height: height + 'px' }"></div>
    </div>
</template>

<script>
export default {
    props: {
        height: {
            type: Number,
            default: 34
        }
    }
}
</script>

<style scoped>
    .placeload .image-placeholder {
        width: 100%;
        min-width:100px;
    }

    .loads {
        -webkit-animation-duration: 1s;
        animation-duration: 1s;
        -webkit-animation-fill-mode: forwards;
        animation-fill-mode: forwards;
        -webkit-animation-iteration-count: infinite;
        animation-iteration-count: infinite;
        -webkit-animation-name: placeload;
        animation-name: placeload;
        -webkit-animation-timing-function: linear;
        animation-timing-function: linear;
        background: #f6f7f8;
        background: #eeeeee;
        background: -webkit-gradient(linear, left top, right top, color-stop(8%, #eeeeee), color-stop(18%, #dddddd), color-stop(33%, #eeeeee));
        background: -webkit-linear-gradient(left, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
        background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
        -webkit-background-size: 800px 104px;
        background-size: 1200px 104px;
        position: relative;
    }

    @-webkit-keyframes placeload {
        0% {
            background-position: -468px 0;
        }
        100% {
            background-position: 468px 0;
        }
    }

    @keyframes placeload {
        0% {
            background-position: -468px 0;
        }
        100% {
            background-position: 468px 0;
        }
    }
</style>